import {IActivityThemeImageDraw} from "@/model/activity";

export interface ICard {
    card_id: string;
    internal_name: string;
    header_image_url: string;
    margin: number[];
    draws: IActivityThemeImageDraw[]
    footer_image_url: string;
}
export class Cards {
    constructor(public readonly data: { [key: string]: ICard }) {
        //
    }

}
